import { clsx } from 'clsx'
import { createSkeletonClass } from '../../../components/skeleton/SkeletonHelper'
import P from '../../../elements/P'

type CardTypeTextProps = {
  isCredit: boolean
  skeleton: boolean
}

const CardTypeText = ({ isCredit, skeleton }: CardTypeTextProps) => {
  const cardType = isCredit ? 'Credit' : 'Debit'
  return (
    <span
      className={clsx(
        'dnb-payment-card__card__element--wrapper',
        createSkeletonClass('font', skeleton)
      )}
    >
      <P className="dnb-payment-card__card__type-text">{cardType}</P>
    </span>
  )
}

export default CardTypeText
